import { DEFAULT_INTL_CONFIG } from "@formatjs/intl";
import { assignUniqueKeysToFormatXMLElementFnArgument } from "./formatMessage";
const processIntlConfig = ({ locale, timeZone, fallbackOnEmptyString, formats, messages, defaultLocale, defaultFormats, onError, onWarn, defaultRichTextElements: rawDefaultRichTextElements, }) => ({
    locale,
    timeZone: timeZone || DEFAULT_INTL_CONFIG.timeZone,
    fallbackOnEmptyString: fallbackOnEmptyString || DEFAULT_INTL_CONFIG.fallbackOnEmptyString,
    formats: formats || DEFAULT_INTL_CONFIG.formats,
    messages,
    defaultLocale: defaultLocale || DEFAULT_INTL_CONFIG.defaultLocale,
    defaultFormats: defaultFormats || DEFAULT_INTL_CONFIG.defaultFormats,
    onError: onError || DEFAULT_INTL_CONFIG.onError,
    onWarn: onWarn || DEFAULT_INTL_CONFIG.onWarn,
    defaultRichTextElements: assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements),
});
export { processIntlConfig };
